import { gql } from "@apollo/client";
import moment from "moment";

const updateSurveyRes = gql`
mutation updateSurveyResp($id: bigint = "", $response_details: jsonb = "", $created_at: timestamptz = "") {
  update_survey_responses_by_pk(pk_columns: {id: $id}, _set: {response_details: $response_details, created_at: $created_at}) {
    id
  }
}
`

export const UpdateSurveyResponse = async (
    data,
    client,
) => {
    try {
        // const loginId = JSON.parse(localStorage.getItem('gogo_current_user')).id
        // const merchantId = JSON.parse(localStorage.getItem('gogo_current_user')).merchant_id

        const resp = await client.mutate({
            mutation: updateSurveyRes,
            // refetchQueries: [getQuery],
            variables: {
                "id": data.res_id,
                "response_details": data,
                "created_at": moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSSSS[+00:00]')
            },
            context: {
                headers: {
                    "Content-Type": "application/json",
                    //   "x-hasura-admin-secret": "aseraadmin@1234",
                    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
                },
            },
        });
        if (resp.errors) {
            return { success: false }
        }
        // window.location.reload();
    } catch (e) {
        console.log(JSON.stringify(e));
        // showFailureAlert('Something went wrong while updating your cart');
    }
    return { success: true }
};
